/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
    NotificationPreferenceDeliveryScopeTypeToJSONTyped,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface PreferenceDeliveryScopeApplyToAllRequest
 */
export interface PreferenceDeliveryScopeApplyToAllRequest {
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    preference_id: string;
    /**
     * 
     */
    delivery_scope: NotificationPreferenceDeliveryScopeType;
}



/**
 * Check if a given object implements the PreferenceDeliveryScopeApplyToAllRequest interface.
 */
export function instanceOfPreferenceDeliveryScopeApplyToAllRequest(value: object): value is PreferenceDeliveryScopeApplyToAllRequest {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('preference_id' in value) || value['preference_id'] === undefined) return false;
    if (!('delivery_scope' in value) || value['delivery_scope'] === undefined) return false;
    return true;
}

export function PreferenceDeliveryScopeApplyToAllRequestFromJSON(json: any): PreferenceDeliveryScopeApplyToAllRequest {
    return PreferenceDeliveryScopeApplyToAllRequestFromJSONTyped(json, false);
}

export function PreferenceDeliveryScopeApplyToAllRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferenceDeliveryScopeApplyToAllRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'preference_id': json['preference_id'],
        'delivery_scope': NotificationPreferenceDeliveryScopeTypeFromJSON(json['delivery_scope']),
    };
}

export function PreferenceDeliveryScopeApplyToAllRequestToJSON(json: any): PreferenceDeliveryScopeApplyToAllRequest {
    return PreferenceDeliveryScopeApplyToAllRequestToJSONTyped(json, false);
}

export function PreferenceDeliveryScopeApplyToAllRequestToJSONTyped(value?: PreferenceDeliveryScopeApplyToAllRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'preference_id': value['preference_id'],
        'delivery_scope': NotificationPreferenceDeliveryScopeTypeToJSON(value['delivery_scope']),
    };
}

